module.exports = __webpack_public_path__ + "static/media/r4s5.baaf1fb0.jpg";